import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isValid: true
  },
  getters: {
    // 实时监听state值的变化(最新状态)
    valid(state) {
      return state.isValid;
    }
  },
  mutations: {
    passValid(state) {
      state.isValid = false;
    },
    noValid(state) {
      state.isValid = true;
    }
  },
  actions: {
    passValid(context) {
      context.commit('passValid');
    },
    noValid(context) {
      context.commit('noValid');
    }
  },
  modules: {
  }
});
